export default __webpack_public_path__ + "static/media/dietly-mobile.75b9e064.svg";